import React from 'react';

import { css } from '@emotion/react';
import { CssVars, mediaQueryForExperimentalLayoutSizeMDOrSmaller } from '@robinhood/design';

import GradientBackground from 'src/components/creditApplication/GradientBackground';
import { CREDIT_APPLICATION_PAGE_MAX_WIDTH } from 'src/components/creditApplication/constants/dimensions';

const GradientBackgroundLayout = ({ children }: React.PropsWithChildren) => {
  return (
    <div css={root}>
      <GradientBackground>
        <div css={page}>{children}</div>
      </GradientBackground>
    </div>
  );
};

const root = css`
  width: 100vw;
  height: 100%;
  background-color: ${CssVars.neutral.bg1};
`;

const page = css`
  height: 100%;
  margin: auto;
  self-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: calc(120px + env(safe-area-inset-top));
  padding-left: 44px;
  padding-right: 44px;
  padding-bottom: 44px;
  max-width: ${CREDIT_APPLICATION_PAGE_MAX_WIDTH}px;

  ${mediaQueryForExperimentalLayoutSizeMDOrSmaller} {
    padding-top: calc(44px + env(safe-area-inset-top));
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 24px;
  }
`;

export default GradientBackgroundLayout;
